import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  acceptedJourneyFirstPax,
  acceptedJourneySecondPax,
  fullyAcceptedjourney,
  journeysManageCheckin,
  notAcceptedjourney,
  partialAcceptedjourneyManageCheckin,
  seatmap,
} from '../../mock/data';

export const journeyElementIds = journeysManageCheckin[0].journeyElements.map((je: JourneyElementCommon) => je.id);

export const ow1journey2AdtUnselectedPassengerManageCheckedInPax: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(journeysManageCheckin, 201),
    createMockDataWithResponse(combineJourneys([partialAcceptedjourneyManageCheckin]).items, 201),
    createMockDataWithResponse(combineJourneys([partialAcceptedjourneyManageCheckin]).items, 201),
    createMockDataWithResponse(combineJourneys([fullyAcceptedjourney]).items, 201)
  ],
  retrieveJourney: [
    createMockData(notAcceptedjourney),
    createMockData(acceptedJourneyFirstPax),
    createMockData(acceptedJourneyFirstPax),
    createMockData(partialAcceptedjourneyManageCheckin),
    createMockData(acceptedJourneySecondPax),
    createMockData(acceptedJourneyFirstPax)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  removeTravelersFromJourney: [createMockData({})]
};
